<template>
    <div class="fullWidth">
        <kgr-loading
            v-if="loading"
            :inline="true"
        />
        <kgr-generic-select
            v-else
            v-model="selection"
            :options="options"
            display="name"
            @post-input="updateLanguage()"
        />
    </div>
</template>

<script>
import GenericSelect from './GenericSelect.vue';
import LanguagesRepository from '../../../../js/repository/LanguagesRepository';
import Loading from '../../Loading.vue';

export default {
    components: {
        'kgr-generic-select': GenericSelect,
        'kgr-loading': Loading,
    },
    props: {
        value: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            options: [],
            selection: null,
            loading: true,
        };
    },
    created() {
        LanguagesRepository.findAll()
            .then((languages) => {
                this.loading = false;
                this.options = languages;

                languages.forEach((language) => {
                    if (language.code === this.value.code) {
                        this.selection = language;
                    }
                });
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        updateLanguage() {
            this.$emit('input', this.selection);
            this.$nextTick(() => {
                this.$emit('post-input', this.selection);
            });
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .fullWidth {
    width: 100%;
}
</style>
